import React from 'react';
import { Link } from 'react-router-dom';
const Privacy = () => {
  return <div className="bg-amber-50 min-h-screen py-12" data-id="element-1778">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1779">
        <div className="mb-8" data-id="element-1780">
          <Link to="/" className="text-amber-800 hover:text-amber-900 flex items-center" data-id="element-1781">
            <svg className="h-5 w-5 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-1782">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 19l-7-7m0 0l7-7m-7 7h18" data-id="element-1783"></path>
            </svg>
            Back to Home
          </Link>
        </div>
        <div className="bg-white shadow rounded-lg overflow-hidden" data-id="element-1784">
          <div className="px-6 py-4 border-b border-gray-200" data-id="element-1785">
            <h1 className="text-2xl font-semibold text-amber-900" data-id="element-1786">
              Privacy Policy
            </h1>
            <p className="text-sm text-amber-800" data-id="element-1787">Last Updated: June 1, 2023</p>
          </div>
          <div className="p-6" data-id="element-1788">
            <section className="mb-8" data-id="element-1789">
              <h2 className="text-xl font-semibold text-amber-900 mb-4" data-id="element-1790">
                Introduction
              </h2>
              <p className="text-amber-800 mb-4" data-id="element-1791">
                Jose's Kare-Kare and Bulalo House ("we," "our," or "us") is
                committed to protecting your privacy. This Privacy Policy
                explains how we collect, use, disclose, and safeguard your
                information when you visit our website and use our services,
                including our online ordering platform.
              </p>
              <p className="text-amber-800" data-id="element-1792">
                We adhere to the Data Privacy Act of 2012 (Republic Act No.
                10173) and implement reasonable data protection measures.
              </p>
            </section>
            <section className="mb-8" data-id="element-1793">
              <h2 className="text-xl font-semibold text-amber-900 mb-4" data-id="element-1794">
                Information We Collect
              </h2>
              <p className="text-amber-800 mb-4" data-id="element-1795">
                We may collect the following types of information:
              </p>
              <h3 className="text-lg font-medium text-amber-900 mb-2" data-id="element-1796">
                Personal Information
              </h3>
              <ul className="list-disc pl-5 mb-4 text-amber-800" data-id="element-1797">
                <li data-id="element-1798">Name</li>
                <li data-id="element-1799">Email address</li>
                <li data-id="element-1800">Phone number</li>
                <li data-id="element-1801">Delivery address</li>
                <li data-id="element-1802">
                  Payment information (processed securely through our payment
                  providers)
                </li>
                <li data-id="element-1803">Account login credentials</li>
              </ul>
              <h3 className="text-lg font-medium text-amber-900 mb-2" data-id="element-1804">
                Non-Personal Information
              </h3>
              <ul className="list-disc pl-5 mb-4 text-amber-800" data-id="element-1805">
                <li data-id="element-1806">Browser type</li>
                <li data-id="element-1807">Operating system</li>
                <li data-id="element-1808">IP address</li>
                <li data-id="element-1809">Pages visited</li>
                <li data-id="element-1810">Time and date of visits</li>
                <li data-id="element-1811">Referring website</li>
                <li data-id="element-1812">Order history and preferences</li>
              </ul>
            </section>
            <section className="mb-8" data-id="element-1813">
              <h2 className="text-xl font-semibold text-amber-900 mb-4" data-id="element-1814">
                How We Use Your Information
              </h2>
              <p className="text-amber-800 mb-4" data-id="element-1815">
                We use the information we collect to:
              </p>
              <ul className="list-disc pl-5 text-amber-800" data-id="element-1816">
                <li data-id="element-1817">Process and fulfill your orders</li>
                <li data-id="element-1818">Provide customer support</li>
                <li data-id="element-1819">Improve our website and services</li>
                <li data-id="element-1820">Send promotional communications (with your consent)</li>
                <li data-id="element-1821">Personalize your experience</li>
                <li data-id="element-1822">Process payments</li>
                <li data-id="element-1823">Prevent fraud and enhance security</li>
                <li data-id="element-1824">Comply with legal obligations</li>
              </ul>
            </section>
            <section className="mb-8" data-id="element-1825">
              <h2 className="text-xl font-semibold text-amber-900 mb-4" data-id="element-1826">
                Cookies and Similar Technologies
              </h2>
              <p className="text-amber-800 mb-4" data-id="element-1827">
                We use cookies and similar tracking technologies to track
                activity on our website and hold certain information. Cookies
                are files with small amount of data which may include an
                anonymous unique identifier.
              </p>
              <p className="text-amber-800 mb-4" data-id="element-1828">Types of cookies we use:</p>
              <ul className="list-disc pl-5 text-amber-800" data-id="element-1829">
                <li data-id="element-1830">
                  <strong data-id="element-1831">Essential cookies:</strong> Required for the website
                  to function properly
                </li>
                <li data-id="element-1832">
                  <strong data-id="element-1833">Preference cookies:</strong> Enable the website to
                  remember your preferences
                </li>
                <li data-id="element-1834">
                  <strong data-id="element-1835">Analytics cookies:</strong> Help us understand how
                  visitors interact with our website
                </li>
                <li data-id="element-1836">
                  <strong data-id="element-1837">Marketing cookies:</strong> Used to track visitors
                  across websites to display relevant advertisements
                </li>
              </ul>
            </section>
            <section className="mb-8" data-id="element-1838">
              <h2 className="text-xl font-semibold text-amber-900 mb-4" data-id="element-1839">
                AI Features
              </h2>
              <p className="text-amber-800 mb-4" data-id="element-1840">
                Our website incorporates AI-powered features to enhance your
                experience:
              </p>
              <ul className="list-disc pl-5 text-amber-800" data-id="element-1841">
                <li data-id="element-1842">
                  <strong data-id="element-1843">Personalized recommendations:</strong> We analyze your
                  order history to suggest dishes you might enjoy
                </li>
                <li data-id="element-1844">
                  <strong data-id="element-1845">AI chatbot:</strong> Our customer service chatbot uses
                  natural language processing to assist with inquiries
                </li>
                <li data-id="element-1846">
                  <strong data-id="element-1847">Order optimization:</strong> AI helps us improve
                  delivery routes and preparation times
                </li>
              </ul>
              <p className="text-amber-800 mt-4" data-id="element-1848">
                These AI systems process your data in accordance with this
                privacy policy and are designed to respect your privacy.
              </p>
            </section>
            <section className="mb-8" data-id="element-1849">
              <h2 className="text-xl font-semibold text-amber-900 mb-4" data-id="element-1850">
                Your Rights
              </h2>
              <p className="text-amber-800 mb-4" data-id="element-1851">
                Under the Data Privacy Act of 2012, you have the right to:
              </p>
              <ul className="list-disc pl-5 text-amber-800" data-id="element-1852">
                <li data-id="element-1853">Access the personal information we hold about you</li>
                <li data-id="element-1854">Correct inaccuracies in your personal information</li>
                <li data-id="element-1855">
                  Delete your personal information (with certain exceptions)
                </li>
                <li data-id="element-1856">Object to the processing of your personal information</li>
                <li data-id="element-1857">Withdraw consent previously provided</li>
                <li data-id="element-1858">Data portability</li>
              </ul>
            </section>
            <section className="mb-8" data-id="element-1859">
              <h2 className="text-xl font-semibold text-amber-900 mb-4" data-id="element-1860">
                Contact Us
              </h2>
              <p className="text-amber-800" data-id="element-1861">
                If you have any questions about this Privacy Policy, please
                contact us at:
              </p>
              <div className="mt-4 text-amber-800" data-id="element-1862">
                <p data-id="element-1863">Jose's Kare-Kare and Bulalo House</p>
                <p data-id="element-1864">205 A. Arnaiz St. Libertad, Pasay City, Philippines</p>
                <p data-id="element-1865">Email: privacy@joseskarekare.com</p>
                <p data-id="element-1866">Phone: 09079222970</p>
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>;
};
export default Privacy;